import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box
} from "@mui/material";
import PropTypes from "prop-types";

const FormSystemModal = ({
  open,
  title,
  message,
  fields,
  onSubmit,
  onClose,
  type,
  confirmLabel,
  cancelLabel
}) => {
  const [formState, setFormState] = useState({});

  useEffect(() => {
    if (fields) {
      const initial = {};
      fields.forEach((f) => {
        initial[f.name] = f.value || "";
      });
      setFormState(initial);
    }
  }, [fields]);

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    if (onSubmit) onSubmit(formState);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {message && (
          <Typography sx={{ mb: fields?.length ? 2 : 0 }}>{message}</Typography>
        )}
        {fields && type === "form" && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {fields.map((field) => (
              <TextField
                key={field.name}
                name={field.name}
                label={field.label}
                type={field.type || "text"}
                fullWidth
                value={formState[field.name]}
                onChange={handleChange}
                required={field.required}
              />
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {cancelLabel && <Button onClick={onClose}>{cancelLabel}</Button>}
        <Button onClick={type === "form" ? handleSubmit : onClose} variant="contained">
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FormSystemModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  fields: PropTypes.array,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["form", "message"]).isRequired,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
};

FormSystemModal.defaultProps = {
  fields: [],
  confirmLabel: "OK",
  cancelLabel: undefined,
};

export default FormSystemModal;